<template>
  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th>{{$t('packet_name')}}</th>
        <th>{{$t('status')}}</th>
        <th>{{$t('start_date')}}</th>
        <th>{{$t('finish_date')}}</th>
        <th>{{$t('cancelled_date')}}</th>
        <th>{{$t('remaining_time_title')}}</th>
        <th class="text-right">{{$t('actions_payment')}}</th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="license in licenses" :key="license.companyPackageId">
        <td class="td-style">
          <span class="category-tag">{{ license.packageName }}</span>
        </td>
        <td class="td-style">
          <span class="status-badge" :class="getStatusClass(license.status)">
            {{ $t(license.status) }}
          </span>
        </td>
        <td class="td-style">
          <span class="date-text">{{ formatDate(license.startDate) }}</span>
        </td>
        <td class="td-style">
          <span class="date-text">{{ formatDate(license.endDate) }}</span>
        </td>
        <td class="td-style">
          <span v-if="license.cancelledAt" class="date-text cancelled-date">{{ formatDate(license.cancelledAt) }}</span>
          <span v-else class="date-text">-</span>
        </td>
        <td class="td-style">
          <span class="remaining-time" :class="getRemainingTimeClass(license.remainingDays)">
            {{ getRemainingTimeText(license.remainingDays) }}
          </span>
        </td>
        <td class="td-style action-icons text-right">
          <img src="@/assets/images/editPenOutline.svg" alt="Edit" class="action-icon" @click="() => handleEditLicense(license)" />
        </td>
      </tr>
      <tr v-else>
        <td colspan="7" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{$t('loading')}}</span>
        </td>
      </tr>
      <tr v-if="!loading && licenses.length === 0 ">
        <td colspan="7" class="table-loading">
          <span class="text">{{$t('no_data_found')}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div v-if="detailsModalVisible" class="modal-overlay" @click="hideDetailsModal">
    <div class="modal-container details-modal" @click.stop>
      <div class="modal-body">
        <div class="products-section">
          <h3>{{ $t('product_limits') }}</h3>
          <div class="products-grid">
            <div class="product-detail" v-for="product in selectedLicense.products" :key="product.name">
              <span class="product-name">{{ product.name }}</span>
              <span class="product-limit">{{ product.quantity }} {{ product.unit }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="cancel-btn" @click="hideDetailsModal">
          {{ $t('close') }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import {VueSpinner} from "vue3-spinners";
import AssignProgramModal from "@/components/modals/AssignProgramModal.vue";
import AssignTestModal from "@/components/modals/AssignTestModal.vue";
import AssignGameLabsModal from "@/components/modals/AssignGameLabsModal.vue";

export default {
  components: {
    AssignTestModal,
    AssignProgramModal,
    AssignGameLabsModal,
    VueSpinner
  },

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    addNewLicense: {
      type: Function,
      default: () => {}
    },
    editLicense: {
      type: Function,
      default: () => {}
    },
    licenses: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      details: {},
      assignmentModal: false,
      assignTestModal: false,
      assignGameLabsModal: false,
      selectedDepartmentId: "",
      detailsModalVisible: false,
      selectedLicense: {}
    }
  },

  computed: {
    currentLocale() {
      return localStorage.getItem('userLanguage') || this.$i18n.locale || 'tr';
    },

    localeForDate() {
      const localeMap = {
        'tr': 'tr-TR',
        'en': 'en-US'
      };
      return localeMap[this.currentLocale] || 'tr-TR';
    }
  },

  methods: {

    // ✅ Internal method - Parent'ın editLicense fonksiyonunu çağırır
    handleEditLicense(license) {
      const editData = {
        companyPackageId: license.companyPackageId,
        packageId: license.packageId,
        packageName: license.packageName,
        status: license.status,
        startDate: license.startDate,
        endDate: license.endDate,
        basePrice: license.basePrice,
        notes: license.notes,
        products: license.products || []
      };


      console.log(editData);
      // Parent component'in editLicense fonksiyonunu çağır
      this.editLicense(editData);
    },

    openAssignGameLabsModal(license) {
      this.assignGameLabsModal = true;
      this.selectedDepartmentId = license.licenseId;
    },

    openAssignModal(license) {
      this.assignmentModal = true;
      this.selectedDepartmentId = license.licenseId;
    },

    openAssignTestModal(license) {
      this.assignTestModal = true;
      this.selectedDepartmentId = license.licenseId;
    },

    hideAssignModal() {
      this.assignmentModal = false;
    },

    hideAssignTestModal() {
      this.assignTestModal = false;
    },

    hideAssignGameLabsModal() {
      this.assignGameLabsModal = false;
    },

    hideDetailsModal() {
      this.detailsModalVisible = false;
      this.selectedLicense = {};
    },

    formatDate(dateStr) {
      try {
        if (dateStr && typeof dateStr === 'string' && dateStr.includes('-')) {
          const parts = dateStr.split('-');
          if (parts.length === 3) {
            const [day, month, year] = parts;
            const isoDateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            const date = new Date(isoDateStr);

            if (!isNaN(date.getTime())) {
              const options = {year: 'numeric', month: 'long', day: 'numeric'};
              return date.toLocaleDateString(this.localeForDate, options);
            }
          }
        }

        const date = new Date(dateStr);
        if (!isNaN(date.getTime())) {
          const options = {year: 'numeric', month: 'long', day: 'numeric'};
          return date.toLocaleDateString(this.localeForDate, options);
        }

        return '-';
      } catch (e) {
        return '-';
      }
    },

    getStatusClass(status) {
      const statusMap = {
        'active': 'success',
        'cancelled': 'danger',
        'suspended': 'warning',
        'demo':'info'
      };
      return statusMap[status] || 'primary';
    },

    getRemainingTimeClass(days) {
      if (days <= 0) return 'danger';
      if (days <= 30) return 'warning';
      return 'success';
    },

    getRemainingTimeText(days) {
      if (days <= 0) return this.$t('expired');
      if (days === 1) return `${days} ${this.$t('remaining_day')}`;
      return `${days} ${this.$t('remaining_days')}`;
    }
  }
}
</script>

<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}

.content-table {
  width: 100%;
  border-collapse: collapse;
}

.header-table th {
  padding: 12px 16px;
  text-align: left;
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #667085;
  background-color: #EAECF0;
  border-bottom: 1px solid #EAECF0;
}

.tbody-container .tr-class {
  border-bottom: 1px solid #EAECF0;
  transition: background-color 0.2s ease;
}

.tbody-container .tr-class:hover {
  background-color: #F9FAFB;
}

.td-style {
  padding: 16px;
  font-family: euclid_regular, sans-serif;
  font-size: 14px;
  color: #344054;
  vertical-align: middle;
  text-align: left;
}

.category-tag {
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #101828;
  margin-right: 5px;
}

.category-tag.primary {
  background-color: #4A68F8;
  color: #FFF;
}

.category-tag.warning {
  background-color: #FF8E55;
  color: #FFF;
}

.category-tag.danger {
  background-color: #FF5B5B;
  color: #FFF;
}

.category-tag.success {
  background-color: #00D68F;
  color: #FFF;
}

.text-right {
  text-align: left;
}

.action-icons {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
}

.action-icon {
  width: 18px;
  height: 18px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

.dark-button-sm {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all .2s ease;
  flex-shrink: 0;
  font-family: euclid_medium, sans-serif;
}

.dark-button-sm:hover {
  background-color: #1F2937;
}

.table-loading {
  text-align: center;
  padding: 40px;
  color: #667085;
}

.table-loading .text {
  margin-left: 10px;
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #667085;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 8px;
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  text-align: center;
  display: inline-block;
}

.status-badge.success {
  background-color: #DDFBDE;
  color: #3DA33E;
}

.status-badge.danger {
  background-color: #FEE2E2;
  color: #DC2626;
}

.status-badge.warning {
  background-color: #FEF3C7;
  color: #D97706;
}

.status-badge.primary {
  background-color: #E0E7FF;
  color: #3730A3;
}

.remaining-time {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
}

.remaining-time.success {
  color: #3DA33E;
}

.remaining-time.warning {
  color: #D97706;
}

.remaining-time.danger {
  color: #DC2626;
}

.date-text {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #6B7280;
}

.date-text.cancelled-date {
  color: #DC2626;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background-color: white;
  border-radius: 12px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.details-modal .modal-container {
  max-width: 800px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #E5E7EB;
}

.modal-title {
  font-family: euclid_medium, sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.modal-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.modal-close-btn:hover {
  background-color: #F3F4F6;
}

.modal-body {
  padding: 30px;
}

.license-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.detail-item.full-width {
  grid-column: span 2;
}

.detail-label {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-value {
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #111827;
}

.products-section h3 {
  font-family: euclid_medium, sans-serif;
  font-size: 18px;
  color: #111827;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E5E7EB;
}

.products-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.product-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
}

.product-name {
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #374151;
}

.product-limit {
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #1D4ED8;
  font-weight: 500;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 30px;
  border-top: 1px solid #E5E7EB;
}

.cancel-btn {
  padding: 10px 20px;
  background-color: transparent;
  color: #6B7280;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  cursor: pointer;
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  transition: all 0.2s ease;
}

.cancel-btn:hover {
  background-color: #F3F4F6;
}

@media (max-width: 768px) {
  .license-details-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .products-grid {
    grid-template-columns: 1fr;
  }

  .detail-item.full-width {
    grid-column: span 1;
  }
}
</style>
